"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconAskQuestion = void 0;
var React = __importStar(require("react"));
var IconAskQuestion = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M11.7441,15.8301 C12.2421,15.8301 12.6481,16.1841 12.6481,16.7351 C12.6481,17.2851 12.2421,17.6401 11.7441,17.6401 C11.2321,17.6401 10.8391,17.2851 10.8391,16.7351 C10.8391,16.1841 11.2321,15.8301 11.7441,15.8301 Z M12.1631,6.3594 C14.1041,6.3594 15.3501,7.3694 15.3501,8.9684 C15.3501,10.0564 14.8121,10.6604 13.8031,11.3684 C12.7141,12.1294 12.3471,12.4174 12.3471,13.4264 L12.3471,13.7804 C12.3471,14.1224 12.0981,14.2924 11.7701,14.2924 C11.4301,14.2924 11.1671,14.1224 11.1671,13.7804 L11.1671,13.4134 C11.1671,12.5884 11.2981,12.1554 11.6521,11.7094 C11.9141,11.3684 12.0591,11.2374 12.8321,10.7134 C13.8031,10.0304 14.0911,9.6894 14.0911,9.0214 C14.0911,8.0504 13.3441,7.4344 12.0981,7.4344 C10.8921,7.4344 10.2231,8.0504 9.9221,8.9424 C9.8161,9.2564 9.6061,9.3754 9.3711,9.3754 C9.2921,9.3754 9.2131,9.3624 9.1351,9.3484 C8.8861,9.2834 8.6491,9.1264 8.6491,8.8384 C8.6491,8.7724 8.6631,8.6934 8.6881,8.6144 C8.8721,8.0384 9.2001,7.5134 9.6721,7.1204 C10.2361,6.6474 11.0221,6.3594 12.1631,6.3594 Z M12,21 C16.963,21 21,16.963 21,12 C21,7.037 16.963,3 12,3 C7.037,3 3,7.037 3,12 C3,16.963 7.037,21 12,21 Z M12,2 C17.514,2 22,6.486 22,12 C22,17.514 17.514,22 12,22 C6.486,22 2,17.514 2,12 C2,6.486 6.486,2 12,2 Z" }))); };
exports.IconAskQuestion = IconAskQuestion;
exports.IconAskQuestion.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconAskQuestion;
